<template>
  <vs-dropdown
    vs-custom-content
    vs-trigger-click
    class="user-dropdown-component cursor-pointer"
    :class="{ 'user-dropdown-component--min': verticalNavMenuItemsMin }">
    <div class="con-img">
      <img
        v-if="activeUserInfo.image"
        key="onlineImg"
        :src="activeUserInfo.image"
        alt="user-img"
        :width="verticalNavMenuItemsMin ? '24' : '40'"
        :height="verticalNavMenuItemsMin ? '24' : '40'"
        class="rounded-full shadow-md cursor-pointer block"
      />
    </div>

    <vs-dropdown-menu class="vx-navbar-dropdown">
      <ul style="min-width: 9rem">
        <li v-if="!twoFactorActivated"
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="$router.push(formatRouteTenant('/user-settings')).catch(() => {})"
        >
          <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
          <span class="ml-2">Configurações</span>
        </li>

        <vs-divider class="m-1"/>

        <li
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="logout"
        >
          <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">Logout</span>
        </li>
      </ul>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import { formatRouteTenantPath, getIp } from '@/utils'
  import user from '@/http/requests/user'
  import { disconnect } from "@/websockets/client.js"

  export default {
    data() {
    return {
      twoFactorActivated: false
    }
  },
    props: {
      verticalNavMenuItemsMin: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      }
    },
    methods: {
      formatRouteTenant(route) {
        return formatRouteTenantPath(route)
      },
      async logout() {
        try {
          const ip = await getIp();
          const payload = {
            ip: ip
          };

          await user.disconnected(ip);

          if (localStorage.getItem("accessToken")) {
            await this.$store.dispatch("auth/disconnected", payload)
            .then((response) => {
              localStorage.removeItem("accessToken");
              localStorage.removeItem("groupsSelectedFilter")
              localStorage.removeItem("connectionDatabase")
              localStorage.removeItem("imageState")
              if(response === 'Successfully disconnected expiration is true'){
                localStorage.setItem('email', this.activeUserInfo.email);
                localStorage.setItem('expiration', true)
              }
            })
          }

          this.$acl.change("administrador");
          localStorage.removeItem("userInfo");

          this.$router.push(formatRouteTenantPath("/login")).catch(() => {});

          disconnect(ip);
        } catch (error) {
          console.error("Erro durante o logout:", error);
        }
      }
    },
    watch: {
      '$store.state.AppActiveUser': {
      handler(newVal, oldVal) {
          if (newVal.twofactor_activity && !newVal.is_two_factor_validated) {
            this.twoFactorActivated = true;
          } else {
            this.twoFactorActivated = false;
          }
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss">
.user-dropdown-component {
  padding: 0px;

  &--min {
    padding: 10px 10px;
  }
}
</style>